/**
 * Created by iamso on 11.03.2022
 */

const RestoreProgressButton = cleverapps.UI.Button.extend({
    alwaysOn: true,

    ctor: function () {
        const styles = cleverapps.styles.RestoreProgressButton;
        const width = styles.width[cleverapps.resolution.mode];
        const height = styles.height;

        const content = this.content = cleverapps.UI.generateOnlyText(Messages.get("RestoreProgress"), cleverapps.styles.FONTS.BUTTON_TEXT);
        content.setDimensions(width, 0);
        content.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        content.fitTo(undefined, height);

        this._super({
            width,
            height,
            content,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            onClicked: function () {
                cleverapps.restoreProgress.restore();
            }
        });

        this.content.setAlignment(styles.content);

        this.setCascadeOpacityEnabledRecursively(true);
        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 9); // higher than scene film effect and shadow
        this._setGlobalZOrder(true);

        cleverapps.restoreProgress.onUpdate = this.createListener(this.updateDynamicPosition.bind(this));
        cleverapps.restoreProgress.onRemove = this.createListener(this.onRemove.bind(this));

        this.onResize();
        this.hide(true);
    },

    onResize: function () {
        const styles = cleverapps.styles.RestoreProgressButton;
        const width = styles.width[cleverapps.resolution.mode];
        const height = styles.height;

        this.resize(width, height);
        this.content.setFontSize(cleverapps.styles.FONTS.BUTTON_TEXT.size);
        this.content.setDimensions(width, 0);
        this.content.fitTo(undefined, height);

        this.content.setAlignment(styles.content);
    },

    onRemove: function () {
        if (this.removing) {
            return;
        }
        this.removing = true;

        this.updateDynamicPosition = function () {};

        this.stopAllActions();
        this.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.RemoveSelf()
        ));
    },

    updateDynamicPosition: function (silent) {
        if (!cleverapps.restoreProgress.isVisible()) {
            this.hide(silent);
            return;
        }

        const scene = cleverapps.Scenes.GetRunningScene();
        const avoidNodes = scene.sceneComponent.getAvoidNodes(RestoreProgressButton.OverlappingNodes)
            .filter(HidingComponent.isNodeShown);

        this.showOverlappingNodes(avoidNodes);

        const styles = cleverapps.styles.RestoreProgressButton;
        let preferredPositions = styles.position;
        if (this.preferredPosition) {
            preferredPositions = [this.preferredPosition].concat(preferredPositions);
        }

        const position = cleverapps.UI.findPosition(this, {
            preferredPositions,
            avoidNodes,
            offset: styles.offset
        });

        this.preferredPosition = position && position.preferred || this.preferredPosition;

        if (!position) {
            this.hide(silent);
        } else if (!this.isShown) {
            this.move(position, true);
            this.show(silent);
        } else {
            this.move(position, silent);
        }
    },

    move: function (position, silent) {
        if (cc.pointEqualToPoint(position, this.movePosition, cleverapps.styles.RestoreProgressButton.eps)) {
            return;
        }
        this.stopAllActions();

        this.movePosition = position;

        if (silent) {
            this.setPosition(position.x, position.y);
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.MoveTo(0, position.x, position.y),
            new cc.FadeIn(0.3)
        )).setFinalize(() => {
            this.setOpacity(255);
            this.setPosition(position.x, position.y);
        });
    },

    show: function (silent) {
        if (this.isShown === true) {
            return;
        }
        this.isShown = true;

        this.stopAllActions();
        this.setVisible(true);

        if (silent) {
            this.setOpacity(255);
            return;
        }

        this.runAction(new cc.FadeIn(0.3)).setFinalize(() => {
            this.setOpacity(255);
        });
    },

    hide: function (silent) {
        if (this.isShown === false) {
            return;
        }
        this.isShown = false;

        this.stopAllActions();

        if (silent) {
            this.setVisible(false);
            this.setOpacity(0);
            return;
        }
        
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.FadeOut(0.3)
        )).setFinalize(() => {
            this.setOpacity(0);
            this.setVisible(false);
        });
    },

    showOverlappingNodes: function (nodes) {
        if (!cleverapps.gameModes.showAvoidRects) {
            return;
        }

        cleverapps.Scenes.GetRunningScene().drawRects(nodes.map((node) => {
            const rect = node.getBoundingBoxToWorld();
            rect.name = node.avoidNode;
            return rect;
        }));
    }
});

RestoreProgressButton.OverlappingNodes = ["Window", "FieldView", "MenuBarItemView", "MinimalDialogue", "Panel", "PlayButtonView", "CloseButton", "DialogueView", "ButtonBooster",
    "SwitchButton", "CustomerRecipeIconView", "FlatFieldView"];

cleverapps.styles.RestoreProgressButton = {
    width: [180, 200, 300],
    height: 110,
    eps: 20,
    offset: { x: 20, y: 20 },
 
    position: [
        {
            x: { align: "left", dx: 20 },
            y: { align: "bottom", dy: 20 }
        },
        {
            x: { align: "right", dx: -20 },
            y: { align: "bottom", dy: 20 }
        },
        {
            x: { align: "right", dx: -20 },
            y: { align: "top", dy: -160 }
        }
    ],
    content: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    }
};
